import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { isNonAuthenticatedUrl } from '../components/login/utils';
import { InvestorStatus } from '../components/login/utils/Status';
import { ONBOARDING_PATH } from '../components/main/onboarding/Onbording';
import { checkPrefrencesData } from '../components/main/onboarding/utils';
import { shortMessage } from '../components/main/userAlret';
import { HEADERMENU_PATH } from '../routes/RoutesURL';
import { RootState } from '../store/rootReducer';
// Adjust the import path as necessary

const useShowUserAlert = (isDealAllow: boolean) => {
    const location = useLocation();
    const navigate = useNavigate();
    const investor = useSelector((state: RootState) => state.user.investor);
    const investorStatus = useSelector((state: RootState) => state.user.investor?.status);
    const jwtToken = useSelector((state: RootState) => state.user.jwtToken);

    let message = investorStatus
        ? investorStatus.kyc && shortMessage[investorStatus.kyc.replace(/ +/g, '')]
            ? shortMessage[investorStatus.kyc.replace(/ +/g, '')]
            : investorStatus.accreditation && shortMessage[investorStatus.accreditation.replace(/ +/g, '')]
            ? shortMessage[investorStatus.accreditation.replace(/ +/g, '')]
            : investorStatus.profile && shortMessage[investorStatus.profile.replace(/ +/g, '')]
            ? shortMessage[investorStatus.profile.replace(/ +/g, '')]
            : undefined
        : undefined;

    const HIPL_KYC_status = investor?.kyc?.reviewsV2?.find((i) => i.entity === 'HIPL')?.status;

    const showHIPLBanner =
        investor?.isHIPL &&
        (HIPL_KYC_status === InvestorStatus.PendingKYCAdditionalDetails ||
            HIPL_KYC_status === InvestorStatus.PendingKYCSubmission);

    const isShow = useMemo(() => {
        const HIPL_KYC_status = investor?.kyc?.reviewsV2?.find((i) => i.entity === 'HIPL')?.status;
        const deal_path = isDealAllow ? true : !location.pathname.includes('/deal/');
        if (
            jwtToken &&
            (investorStatus?.kyc === InvestorStatus.PendingKYCAdditionalDetails ||
                investorStatus?.kyc === InvestorStatus.PendingKYCReview ||
                investorStatus?.kyc === InvestorStatus.PendingKYCResubmissionReview ||
                investorStatus?.kyc === InvestorStatus.PendingKYCResubmission ||
                investorStatus?.kyc === InvestorStatus.PendingKYCSubmission ||
                investorStatus?.profile === InvestorStatus.PendingPostAIAgreements ||
                investorStatus?.accreditation === InvestorStatus.PendingAIResubmission ||
                investorStatus?.accreditation === InvestorStatus.PendingAIReview ||
                (investorStatus?.accreditation === InvestorStatus.PendingAISubmission &&
                    investor?.investorType !== 'Institutional') ||
                (investor?.isHIPL &&
                    (HIPL_KYC_status === InvestorStatus.PendingKYCReview ||
                        HIPL_KYC_status === InvestorStatus.PendingKYCResubmissionReview ||
                        HIPL_KYC_status === InvestorStatus.PendingKYCAdditionalDetails ||
                        HIPL_KYC_status === InvestorStatus.PendingKYCSubmission ||
                        HIPL_KYC_status === InvestorStatus.PendingKYCResubmission)) ||
                !investor?.preferences) &&
            deal_path &&
            !location.pathname.includes(`${HEADERMENU_PATH.investments}/`) &&
            location.pathname !== HEADERMENU_PATH.PDFView &&
            !location.pathname.includes(HEADERMENU_PATH.onboarding) &&
            !location.pathname.includes(HEADERMENU_PATH.settings) &&
            location.pathname !== HEADERMENU_PATH.referral &&
            !isNonAuthenticatedUrl(location.pathname)
        ) {
            return true;
        }
        return false;
    }, [investorStatus, jwtToken, location.pathname, investor, isDealAllow]);

    const countText = useMemo(() => {
        if (!investor || !checkPrefrencesData(investor.preferences)) {
            if (
                (investorStatus?.kyc === InvestorStatus.PendingKYCAdditionalDetails ||
                    investorStatus?.kyc === InvestorStatus.PendingKYCSubmission ||
                    investorStatus?.kyc === InvestorStatus.PendingKYCResubmission ||
                    showHIPLBanner) &&
                (investorStatus?.accreditation === InvestorStatus.PendingAIResubmission ||
                    investorStatus?.accreditation === InvestorStatus.PendingAISubmission) &&
                investor?.investorType !== 'Institutional'
            ) {
                return 'Three steps away from finalising your account.';
            } else if (
                investorStatus?.kyc === InvestorStatus.PendingKYCAdditionalDetails ||
                investorStatus?.kyc === InvestorStatus.PendingKYCSubmission ||
                investorStatus?.kyc === InvestorStatus.PendingKYCResubmission ||
                showHIPLBanner
            ) {
                return 'Two steps away from finalising your account.';
            } else if (
                (investorStatus?.accreditation === InvestorStatus.PendingAIResubmission ||
                    investorStatus?.accreditation === InvestorStatus.PendingAISubmission) &&
                investor?.investorType !== 'Institutional'
            ) {
                return 'Two steps away from finalising your account.';
            }
            return 'One step away from finalising your account.';
        } else if (
            (investorStatus?.kyc === InvestorStatus.PendingKYCAdditionalDetails ||
                investorStatus?.kyc === InvestorStatus.PendingKYCSubmission ||
                investorStatus?.kyc === InvestorStatus.PendingKYCResubmission ||
                showHIPLBanner) &&
            (investorStatus?.accreditation === InvestorStatus.PendingAIResubmission ||
                investorStatus?.accreditation === InvestorStatus.PendingAISubmission ||
                investorStatus?.accreditation === InvestorStatus.PendingAIAdditionalDetails) &&
            investor?.investorType !== 'Institutional'
        ) {
            return 'Two steps away from finalising your account.';
        }
        if (
            investorStatus?.kyc === InvestorStatus.PendingKYCAdditionalDetails &&
            investorStatus?.accreditation === InvestorStatus.PendingAIAdditionalDetails &&
            investor?.investorType !== 'Institutional'
        ) {
            return 'Your Accreditation and KYC information has been reviewed by our team and requires updating.';
        }

        if (
            investorStatus?.accreditation === InvestorStatus.PendingAIAdditionalDetails &&
            investor?.investorType !== 'Institutional'
        ) {
            return 'Your Accreditation information has been reviewed by our team and requires updating.';
        }

        if (investorStatus?.kyc === InvestorStatus.PendingKYCAdditionalDetails) {
            return 'Your KYC information has been reviewed by our team and requires updating.';
        }

        if (
            investorStatus?.kyc === InvestorStatus.PendingKYCResubmission &&
            investorStatus?.accreditation === InvestorStatus.PendingAIResubmission &&
            investor?.investorType !== 'Institutional'
        ) {
            return 'Your Accreditation or KYC information requires updating.';
        }

        if (
            investorStatus?.accreditation === InvestorStatus.PendingAIResubmission &&
            investor?.investorType !== 'Institutional'
        ) {
            return 'Your Accreditation information requires updating.';
        }

        if (investorStatus?.kyc === InvestorStatus.PendingKYCResubmission) {
            return 'Your KYC information requires updating.';
        }

        if (
            investorStatus?.kyc === InvestorStatus.PendingKYCReview ||
            investorStatus?.kyc === InvestorStatus.PendingKYCResubmissionReview ||
            investorStatus?.accreditation === InvestorStatus.PendingKYCReview ||
            investorStatus?.accreditation === InvestorStatus.PendingKYCResubmissionReview
        ) {
            return `Our team is currently reviewing your details. You will be updated once complete. If you have any queries, please contact us at <a href="mailto:admin@heli-cap.com" class="text-blue-400">admin@heli-cap.com</a>`;
        } else if (
            investorStatus?.kyc === InvestorStatus.PendingKYCAdditionalDetails ||
            investorStatus?.kyc === InvestorStatus.PendingKYCSubmission ||
            investorStatus?.kyc === InvestorStatus.PendingKYCResubmission ||
            showHIPLBanner
        ) {
            return 'One step away from finalising your account.';
        } else if (
            (investorStatus?.accreditation === InvestorStatus.PendingAIResubmission ||
                investorStatus?.accreditation === InvestorStatus.PendingAISubmission ||
                investorStatus?.accreditation === InvestorStatus.PendingAIAdditionalDetails) &&
            investor?.investorType !== 'Institutional'
        ) {
            return 'One step away from finalising your account.';
        }
        return 'One step away from finalising your account.';
    }, [investor, investorStatus, showHIPLBanner]);

    //Comment add
    if (!message && investor?.isHIPL) {
        message = HIPL_KYC_status ? shortMessage[HIPL_KYC_status.replace(/ +/g, '')] : undefined;
    }
    const isShowButton = useMemo(() => {
        if (
            investorStatus?.kyc === InvestorStatus.PendingKYCAdditionalDetails ||
            investorStatus?.kyc === InvestorStatus.PendingKYCResubmission ||
            investorStatus?.kyc === InvestorStatus.PendingKYCSubmission ||
            investorStatus?.accreditation === InvestorStatus.PendingAIAdditionalDetails ||
            investorStatus?.accreditation === InvestorStatus.PendingAIResubmission ||
            investorStatus?.accreditation === InvestorStatus.PendingAISubmission ||
            (investor && !checkPrefrencesData(investor.preferences)) ||
            showHIPLBanner
        ) {
            return true;
        }
        if (investor?.isHIPL && HIPL_KYC_status) {
            return shortMessage[HIPL_KYC_status.replace(/ +/g, '')];
        }
        return false;
    }, [investorStatus, showHIPLBanner, investor, HIPL_KYC_status]);

    const redirectToSetting = () => {
        if (!investor || !checkPrefrencesData(investor.preferences)) {
            navigate(`${HEADERMENU_PATH.onboarding}/${ONBOARDING_PATH.INVESTMENT_PREFERENCES}`);
        } else {
            if (
                investor.status.accreditation === InvestorStatus.PendingAIAdditionalDetails &&
                investor.investorType !== 'Institutional'
            ) {
                navigate(`${HEADERMENU_PATH.onboarding}/${ONBOARDING_PATH.ACCREDITED_INVESTOR}`);
                return;
            }

            if (investor.status.kyc === InvestorStatus.PendingKYCAdditionalDetails) {
                if ((!investor || !investor.kyc || !investor.kyc.info) && investor.investorType !== 'Institutional') {
                    navigate(`${HEADERMENU_PATH.onboarding}/${ONBOARDING_PATH.KYC}`, {
                        state: {
                            selectedType: investor.investorType === 'Individual Accredited' ? 'cards' : 'Manuald',
                        },
                    });
                } else {
                    navigate(`${HEADERMENU_PATH.onboarding}/${ONBOARDING_PATH.KYC}`, {
                        state: { selectedType: 'Manual' },
                    });
                }
                return;
            }
            if (
                (investor.status.accreditation === InvestorStatus.PendingAIResubmission &&
                    investor?.investorType !== 'Institutional') ||
                (investor.status.accreditation === InvestorStatus.PendingAISubmission &&
                    investor?.investorType !== 'Institutional')
            ) {
                navigate(`${HEADERMENU_PATH.onboarding}/${ONBOARDING_PATH.ACCREDITED_INVESTOR}`);
                return;
            }

            if (
                investor.status.kyc === InvestorStatus.PendingKYCSubmission ||
                investor.status.kyc === InvestorStatus.PendingKYCResubmission
            ) {
                if ((!investor || !investor.kyc || !investor.kyc.info) && investor.investorType !== 'Institutional') {
                    navigate(`${HEADERMENU_PATH.onboarding}/${ONBOARDING_PATH.KYC}`, {
                        state: {
                            selectedType: investor.investorType === 'Individual Accredited' ? 'cards' : 'Manuald',
                        },
                    });
                } else {
                    navigate(`${HEADERMENU_PATH.onboarding}/${ONBOARDING_PATH.KYC}`, {
                        state: { selectedType: 'Manual' },
                    });
                }
                return;
            }

            if (
                investor.status.accreditation !== InvestorStatus.AIApproved &&
                investor.investorType !== 'Institutional'
            ) {
                navigate(`${HEADERMENU_PATH.onboarding}/${ONBOARDING_PATH.ACCREDITED_INVESTOR}`);
            } else {
                if ((!investor || !investor.kyc || !investor.kyc.info) && investor.investorType !== 'Institutional') {
                    navigate(`${HEADERMENU_PATH.onboarding}/${ONBOARDING_PATH.KYC}`, {
                        state: {
                            selectedType: investor.investorType === 'Individual Accredited' ? 'cards' : 'Manuald',
                        },
                    });
                } else {
                    navigate(`${HEADERMENU_PATH.onboarding}/${ONBOARDING_PATH.KYC}`, {
                        state: { selectedType: 'Manual' },
                    });
                }
            }
        }
    };

    return { isShow, countText, isShowButton, showHIPLBanner, message, redirectToSetting };
};

export default useShowUserAlert;
